import PropTypes from 'prop-types';
import { css, cx } from '@eti/styles';
import { breakpoints, Button, Card, Heading, Stack } from '@etg/wings';

export const BUTTONS_LAYOUT = { HORIZONTAL: 'horizontal', VERTICAL: 'vertical' };

const wrapperStyles = css`
  margin-top: 24px;

  @media (min-width: ${breakpoints._970}) {
    margin-top: 35px;
  }
`;

const buttonsWrapperStyles = (layout) => css`
  clear: both;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: ${breakpoints._768}) {
    flex-direction: ${layout === BUTTONS_LAYOUT.HORIZONTAL ? 'row' : 'column'};
    justify-content: ${layout === BUTTONS_LAYOUT.HORIZONTAL && 'flex-end'};
  }
`;

const PageSection = ({
  children,
  dataTestId,
  id,
  heading: { as = null, level = 2, title = null } = {},
}) => (
  <Stack className={wrapperStyles} data-testid={dataTestId} id={id} spacing={16}>
    <Heading as={as} level={level}>
      {title}
    </Heading>
    <div>{children}</div>
  </Stack>
);

PageSection.propTypes = {
  children: PropTypes.node,
  dataTestId: PropTypes.string,
  heading: PropTypes.shape({
    as: PropTypes.string,
    level: PropTypes.number,
    title: PropTypes.string,
  }),
  id: PropTypes.string,
};

const PageSectionHead = ({ children, className, dataTestId }) => (
  <div className={className} data-testid={dataTestId}>
    {children}
  </div>
);

PageSectionHead.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
};

const PageSectionBody = ({
  buttons,
  buttonsLayout = BUTTONS_LAYOUT.VERTICAL,
  children,
  classNames,
  dataTestId,
}) => (
  <Card className={classNames?.contentStyles} data-testid={dataTestId}>
    {children}
    {buttons && (
      <div className={cx(buttonsWrapperStyles(buttonsLayout), classNames?.buttonsWrapper)}>
        {buttons.map((button) => {
          const { dataTestId: buttonDataTestId, text, ...rest } = button;

          return (
            <Button
              className={classNames?.buttonStyles}
              data-testid={buttonDataTestId}
              key={buttonDataTestId}
              {...rest}
            >
              {button.text}
            </Button>
          );
        })}
      </div>
    )}
  </Card>
);

PageSectionBody.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      dataTestId: PropTypes.string,
      text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    }),
  ),
  buttonsLayout: PropTypes.string,
  children: PropTypes.node,
  classNames: PropTypes.shape({
    buttonStyles: PropTypes.string,
    buttonsWrapper: PropTypes.string,
    contentStyles: PropTypes.string,
  }),
  dataTestId: PropTypes.string,
};

PageSection.Head = PageSectionHead;
PageSection.Body = PageSectionBody;

export default PageSection;
